import Metadata from '../Metadata'
import Header from './Need2KnowHeader'
import SignUp from './SignUp'
import style from '../../styles/components/need2know/need2know'

const Need2KnowDetails = ({ need2know: { thumbnail, title, description, heroImage, body } }) => (
  <>
    <Metadata metadata={{ title: `Cheddar News - ${title}`, thumbnail, description }} />
    <div className='container'>
      <div className='need2know-container'>
        <Header body={body} heroImage={heroImage} />
        <SignUp />
      </div>
    </div>
    <style jsx>{style}</style>
  </>
)

export default Need2KnowDetails
